<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-md-8 ">
        <div class="row">
          <div class="col-12 text-center">
            <img
              src="@/assets/images/LogoPIM_WhiteBG.png"
              alt
              class="img-fluid"
              style="width: 340px;"
            />
          </div>

          <div class="col-12 text-center mt-4" v-if="!isAuthStateLoading">
            <button
              class="btn btn-on relative"
              style="width:260px"
              @click="onOauthSigninClick"
            >
              GET STARTED
              <i
                class="fas fa-chevron-right absolute"
                style="right: 10px;top: 10px;"
              />
            </button>
          </div>
          <div class="col-12 text-center mt-4" v-if="!isAuthStateLoading">
            <button
              class="btn btn-on relative"
              style="width:260px"
              @click="onKeyCloakSigninClick"
            >
            <!-- <img src="@/assets/images/keycloak.webp" class="mr-3" width="25px"/> -->
              GET STARTED WITH MARKETPLACE
              <i
                class="fas fa-chevron-right absolute"
                style="right: 10px;top: 10px;"
              />
            </button>
          </div>
          <div class="col-12 login-loading mt-4" v-show="isAuthStateLoading">
            <div class="row">
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-success" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-success"
                  style="margin-top: -25px"
                >
                  <strong>O</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div
                    class="spinner-border text-secondary"
                    role="status"
                  ></div>
                </div>
                <div
                  class="row justify-content-center text-secondary"
                  style="margin-top: -25px"
                >
                  <strong>F</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-danger" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-danger"
                  style="margin-top: -25px"
                >
                  <strong>F</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-warning" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-warning"
                  style="margin-top: -25px"
                >
                  <strong>I</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-info" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-info"
                  style="margin-top: -25px"
                >
                  <strong>C</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-dark" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-dark"
                  style="margin-top: -25px"
                >
                  <strong>E</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-primary" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-primary"
                  style="margin-top: -25px"
                >
                  <strong>M</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-muted" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-muted"
                  style="margin-top: -25px"
                >
                  <strong>A</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-danger" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-danger"
                  style="margin-top: -25px"
                >
                  <strong>T</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-success" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-success"
                  style="margin-top: -25px"
                >
                  <strong>E</strong>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="row justify-content-center mt-4">
                  <button
                    v-if="timerCount == 0"
                    type="button"
                    class="btn relative btn-light btn-outline-info"
                    style="width:260px"
                    @click="$router.push({ name: 'logout' })"
                  >
                    BACK TO LOGIN
                    <i
                      class="fas fa-chevron-left absolute"
                      style="left: 10px;top: 10px;"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="isAuthError">
            <b-alert
              v-model="isAuthError"
              variant="danger"
              class="mt-4"
              dismissible
              >{{ authError }}</b-alert
            >
          </div>
        </div>
        <!-- end card -->
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import axios from 'axios'
import { authMethods, authComputed } from '@/state/helpers'
import * as jwt from '@/helpers/utils/jwt'
import * as date from '@/helpers/utils/date'
import appConfig from '@/app.config'
import authorizeProvider from '@/helpers/service/authorize-provider'

export default {
  page: {
    title: 'Login',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {},
  data() {
    return {
      timerCount: 10,
      authError: null,
      isAuthStateLoading: true,
      isAuthError: false,
      oauthConfig: {
        clientId: process.env.VUE_APP_OAUTH_CLIENT_ID,
        clientSecret: process.env.VUE_APP_OAUTH_CLIENT_SECRET,
        grantType: 'authorization_code',
        redirect_url: `${process.env.VUE_APP_BASE_URL}/login`,
      },
      keyCloakConfig: {
        clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
        grantType: 'authorization_code',
        redirect_url: `${process.env.VUE_APP_BASE_URL}/login/kc/callback`,
      },
    }
  },
  computed: {},
  created() {},
  mounted() {
    if (
      this.$route.query.authorize_code &&
      this.$route.query.access_token_url &&
      this.$route.query.secret_key
    ) {
      this.$cookies.set('.oauth.sk', this.$route.query.secret_key)
      this.getAccessToken(
        this.$route.query.authorize_code,
        this.$route.query.access_token_url
      )
    } else {
      this.checkCookie()
    }
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--
            // console.log(this.timerCount)
          }, 1000)
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  methods: {
    ...authMethods,
    async checkCookie() {
      let accessToken = this.$cookies.get('.oauth.at')
      if (accessToken) {
        var result = await this.checkUserPSGGroup(accessToken)
        if (result) {
          if (jwt.validateExpireAccessToken(accessToken)) {
            this.authen(accessToken)
            return
          }
        }
      }
      this.isAuthStateLoading = false
    },
    async getAccessToken(authorize_code, access_token_url) {

      console.log('access_token_url :>> ', access_token_url);
      const data = JSON.stringify({
        client_id: this.oauthConfig.clientId,
        client_secret: this.oauthConfig.clientSecret,
        grant_type: this.oauthConfig.grantType,
        authorize_code: authorize_code,
      })
      let vm = this
      axios({
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'Post',
        data: data,
        url: access_token_url,
      }).then(
        async function(result) {
          if (result.data.refresh_token && result.data.access_token) {
            var decodeRf = jwt.getUserInfo(result.data.refresh_token)
            var decodeAt = jwt.getUserInfo(result.data.access_token)

            vm.$cookies.set(
              '.oauth.rt',
              result.data.refresh_token,
              date.differentTimeMinutes(decodeRf.exp) * 60
            )
            vm.$cookies.set(
              '.oauth.at',
              result.data.access_token,
              date.differentTimeMinutes(decodeAt.exp) * 60
            )
            let isInGroup = await vm.checkUserPSGGroup(result.data.access_token)
            if (isInGroup) {
              vm.authen(result.data.access_token)
              if (result.data.info && result.data.info != null) {
                let info = JSON.stringify({
                  name: result.data.info.name,
                  email: result.data.info.email,
                  photo: result.data.info.photo,
                })
                vm.$cookies.set('.oauth.usr', info, '1h')
              }
            }
          }
        },
        error => {
          console.log(error.response)
        }
      )
    },
    authen(accessToken) {
      axios({
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'Post',
        data: {
          access_token: accessToken,
        },
        url: `${process.env.VUE_APP_BASE_API}${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/authentications/token/oauth`,
      }).then(
        result => {
          console.log('authentications', result)
          if (result.status == 201) {
            this.setIsAuthenticated({ isAuthenticated: true })
            this.setAccessToken({ accessToken: result.data.token })
            // localStorage.setItem('.psgauth.at', result.data.token)
            this.removeVendorSelected()
            if (
              localStorage.getItem('routeHistory') !== '' &&
              localStorage.getItem('routeHistory') !== undefined &&
              localStorage.getItem('routeHistory') !== null
            )
              this.$router.push({ path: localStorage.getItem('routeHistory') })
            else this.$router.push({ path: '/' })
          }
        },
        error => {
          console.log(error.response)
          if (error.response.status == 404) {
            this.$utils.notification(
              'warning',
              'ไม่สามารถ Login ได้ เนื่องจากคุณยังไม่ได้ทำการ Register ข้อมูล',
              2500
            )
            this.$router.push({ path: '/register' })
          }
        }
      )
    },
    onOauthSigninClick() {
      this.timerCount = 10
      var sk = this.$cookies.get('.oauth.sk')
      if (sk) {
        let queryString = sk
      }
      let scopes = 'default,email,employee'
      let redirect_url = encodeURIComponent(this.oauthConfig.redirect_url)
      let oauthlocation = `${process.env.VUE_APP_BASE_URL_OAuth}authentication/signin?client_id=${this.oauthConfig.clientId}&redirect_uri=${redirect_url}&scopes=${scopes}`
      window.location.href = oauthlocation
    },
    onKeyCloakSigninClick() {
      this.timerCount = 10
      
      let scopes = 'openid'
      let redirect_url = encodeURIComponent(this.keyCloakConfig.redirect_url)
      // 'https://du-kc-authen.ofm.co.th/realms/CHMS/protocol/openid-connect/auth?response_type=code&client_id=pim-client&redirect_uri=https%3A%2F%2Foauth.pstmn.io%2Fv1%2Fcallback'
      let oauthlocation = `${process.env.VUE_APP_BASE_URL_KEYCLOAK}?response_type=code&client_id=${this.keyCloakConfig.clientId}&redirect_uri=${redirect_url}&scopes=${scopes}`
      window.location.href = oauthlocation
    },
    async checkUserPSGGroup(accessToken) {
      // console.log('checkUserPSGGroup')
  console.log('accessToken4 :>> ', accessToken);
      const responsed = await authorizeProvider.getMenuItems(accessToken)
      if (responsed.status == 200) {
        if (
          responsed.data.groups === null ||
          responsed.data.groups.length === 0 ||
          responsed.data.menuItems === null ||
          responsed.data.menuItems.length === 0
        ) {
          this.$router.push({ name: 'Error-401' })
          return false
        }
      } else if (responsed.status == 404) {
        this.$router.push({ name: 'Error-401' })
        return false
      }
      return true
    },
  },
}
</script>
